import { IsoString } from 'models';
import { IContract, ILogo, IPartnerInfo } from '../../../models';
import { ILimitPerClient, IPartnerLimits } from './IPartnerLimits';
import { IPartnerFormFields } from './IPartnerFormFields';

export interface IPartnerList extends Array<IPartner> {}

export interface IPartner extends IPartnerInfo {
	id: string;
	shortName: string;
	formalName: string;
	logoUrl: string;

	primaryColor?: string;
	useAdditionalLogo?: boolean;
	additionalLogoUrl?: string;

	contractStartDate: IsoString;
	contractEndDate: IsoString;
	contractUrl: string;

	website: string;
	comment?: string;
	deleted?: boolean;
}

export interface IPartnerData extends IPartnerLimits {
	id: string;
	shortName: string;
	formalName: string;
	logoUrl: string;
	logoKey: string;
	comment?: string;
	contractDto: IContract;
	integrationId?: number;
	website: string;
	primaryColor: string;
	useAdditionalLogo: boolean;
	additionalLogoFileKey?: string;
	additionalLogoUrl?: string;
}

export interface IPartnerDataPayload extends IPartnerLimits {
	partnerId?: string;
	shortName: string;
	formalName: string;
	logoKey: string;
	contractDto: IContract;
	comment?: string;
	integrationId?: number;
	website?: string;

	primaryColor: string;
	useAdditionalLogo: boolean;
	additionalLogoFileKey: string | null;
	additionalLogoUrl?: string | null;

	limitPerClientDtos?: ILimitPerClient[];
}

export interface IPartnerFormData extends IPartnerForm {
	contractData?: IContract;
	useOptionalHeaderLogoData?: ILogo;
}

export interface IPartnerForm extends Record<string, any> {
	[IPartnerFormFields.formalName]: string;
	[IPartnerFormFields.shortName]: string;
	[IPartnerFormFields.website]?: string;
	[IPartnerFormFields.logo]: string;
	[IPartnerFormFields.primaryColor]: string;
	[IPartnerFormFields.useOptionalHeaderLogo]: boolean;
	[IPartnerFormFields.optionalHeaderLogo]?: string;
	[IPartnerFormFields.organizationIsicCode]?: string;
	[IPartnerFormFields.comment]?: string;
	[IPartnerFormFields.contractStartDate]?: string;
	[IPartnerFormFields.contractEndDate]?: string;
	[IPartnerFormFields.integrationId]?: string;
	[IPartnerFormFields.contract]?: string;

	adminCount?: number;
	partnerUserCount?: number;
	clientCount?: number;
	surveyCount?: number;

	[IPartnerFormFields.adminCountLimit]?: string;
	[IPartnerFormFields.partnerUserCountLimit]?: string;

	[IPartnerFormFields.clientCountLimit]?: string;
	[IPartnerFormFields.surveyCountLimit]?: string;

	[IPartnerFormFields.surveyLimitPerClientDtos]?: string;
}

export enum DynamicValidationFieldNames {
	isSurveyLimitPerClientValid = 'surveyLimitPerClient',
}

export interface IDynamicValidationFields {
	[DynamicValidationFieldNames.isSurveyLimitPerClientValid]?: boolean;
}
